module.exports = __webpack_public_path__ + "static/multiple-users-f0beba551671f95265520870c3c0339d.svg";